<h2 mat-dialog-title class="report-dialog-title"><mat-icon>description</mat-icon>Packet details</h2>
<div mat-dialog-content>
  <dl class="report-detail-list">
    <div><dt>Received</dt><dd>{{ data.when | date: 'medium' }}</dd></div>
    <div><dt>Parser message</dt><dd>{{ data.parserMessage || 'No parser message' }}</dd></div>
    <div><dt>Packet value</dt><dd class="report-payload">{{ data.value }}</dd></div>
  </dl>
</div>
<div mat-dialog-actions class="report-dialog-actions">
  <button mat-flat-button class="report-dialog-primary" [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</div>
